import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  MenuItem,
  Container,
  Grid,
  Typography,
  InputLabel,
  FormControl,
  Box,
  CircularProgress,
  TextField,
  Tabs,
  Tab,
  FormControlLabel,
  Checkbox,
  ListSubheader,
} from "@mui/material";
import Select from "@mui/material/Select";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import Iconify from "../components/iconify";
import OptionDialog from "src/components/pickem-admin/OptionDialog";
import OptionsTable from "src/components/pickem-admin/OptionsTable";
import AssetsDialog from "src/components/pickem-admin/AssetsDialog";
import { QUESTIONS } from "src/constants/pickem";

import OptionsOrderingTable from "../components/pickem-admin/OptionsOrderingTable";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
// ----------------------------------------------------------------------

const isOlybet = process.env.REACT_APP_NAME === "olybet";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}
const rowsTest = [
  createData("Who will win?", ""),
  createData("Who will have more points tonight?", ""),
  createData("Which team will have more shots on net?", ""),
  createData("Will Bo Horvat get over 1.5pts tonight?", ""),
  createData("Which skater will have the best faceoff % tonight?", ""),
];
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}
const defaultQuestionState = {
  title_en: "",
  description_en: "",
  title_fr: "",
  description_fr: "",
  options: [],
  points: 15,
  category: "WINS",
  view_type: "PLAYER_LIST",
  bonus_options: [
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
    { label: "", is_correct: false },
  ],
};

const groupedQuestions = () => {
  return QUESTIONS.reduce((r, a) => {
    r[a.group] = [...(r[a.group] || []), a];
    return r;
  }, {});
};
const dateFormat = "YYYY-MM-DD HH:mm:ss";
export default function PickemQuestinPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [question, setQuestion] = useState(null);
  const [pickemId, setPickemId] = useState(null);
  const [questionId, setQuestionId] = useState(null);
  const [openOptionDialog, setOpenOptionDialog] = useState(false);
  const [editOption, setEditOption] = useState(null);
  const [editOptionIndex, setEditOptionIndex] = useState(null);
  const [assetsTarget, setAssetsTarget] = useState(null);
  const [questionTitleIndex, setQuestionTitleIndex] = useState(0);
  const groupedQuestionsList = groupedQuestions();
  const [isOrderingMode, setIsOrderingMode] = useState(false);

  useEffect(() => {
    if (searchParams.has("pickem_id")) {
      let pickemId = searchParams.get("pickem_id");
      setPickemId(pickemId);
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${pickemId}`)
        .then(function (response) {
          if (searchParams.has("question_id")) {
            const questionId = searchParams.get("question_id");
            const question = response.data.pickem.questions.find(
              (question) => question.question_id === Number(questionId)
            );
            // add default bonus options if they don't exist
            if (!question?.bonus_options?.length < 12) {
              const missOptionsCount = 12 - question?.bonus_options?.length || 0;
              for (let i = 0; i < missOptionsCount; i++) {
                question.bonus_options.push({ label: "", is_correct: false });
              }
            }

            if (question) {
              setQuestion(question);
              const questionIndex = QUESTIONS.findIndex(
                (quest) => quest.titleEn == question.title_en
              );
              if (questionIndex === -1) {
                setQuestionTitleIndex(0);
              } else {
                setQuestionTitleIndex(questionIndex);
              }
            }
          } else {
            setQuestion(defaultQuestionState);
          }
          setLoading(false);
        });
    } else {
      //navigate("/404");
    }
    if (searchParams.has("question_id")) {
      setQuestionId(searchParams.get("question_id"));
    }
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setQuestion((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleChangeBonusOptionLabel = (e, optionIndex) => {
    const { id, value } = e.target;
    question.bonus_options[optionIndex].label = value;
    setQuestion((prevState) => ({
      ...prevState,
      bonus_options: [...question.bonus_options],
    }));
  };
  const deleteImage = (key) => {
    setQuestion((prevState) => ({
      ...prevState,
      [key]: null,
    }));
  };
  const reorderOptionsHandler = (options) => {
    setQuestion({ ...question, options: options });
  };
  const handleChangeCategory = (event) => {
    let points = 1;
    switch(event.target.value) {
      case "WINS":
        points = 15;
        break;
      case "GOALS_AGAINTS":
        points = 10;
        break;
      case "CLEAN_SHEAT":
        points = 20;
        break;
      default: 
        points = 1;
    }
    setQuestion((prevState) => ({
      ...prevState,
      category: event.target.value,
      points
    }));
  };
  const handleChangeQuestionTitle = (event) => {
    setQuestionTitleIndex(event.target.value);
    if (event.target.value > 0) {
      setQuestion((prevState) => ({
        ...prevState,
        title_en: QUESTIONS[event.target.value].titleEn,
        title_fr: QUESTIONS[event.target.value].titleFr ?? "",
        title_sl: QUESTIONS[event.target.value].titleSl ?? "",
        title_es: QUESTIONS[event.target.value].titleEs ?? "",
        title_lt: QUESTIONS[event.target.value].titleLt ?? "",
        title_rus: QUESTIONS[event.target.value].titleRus ?? "",
        title_esp: QUESTIONS[event.target.value].titleEsp ?? "",
        title_de: QUESTIONS[event.target.value].titleDe ?? "",
        question_type: `${QUESTIONS[event.target.value].questionType}:${QUESTIONS[event.target.value].index}`,
      }));
    }
  };
  const handleChangeBonusType = (event) => {
    setQuestion((prevState) => ({
      ...prevState,
      bonus_type: event.target.value,
    }));
  };
  const handleChangeViewType = (event) => {
    setQuestion((prevState) => ({
      ...prevState,
      view_type: event.target.value,
    }));
  };
  const handleQuestionStartChange = (newValue) => {
    setQuestion((prevState) => ({
      ...prevState,
      start_utc: moment(newValue).format(dateFormat), //2022-11-23 23:00:00
    }));
  };
  const handleChangeIsBonus = (e) => {
    setQuestion((prevState) => ({
      ...prevState,
      is_bonus: e.target.checked,
    }));
  };
  const handleChangeIsTieBreak = (e) => {
    setQuestion((prevState) => ({
      ...prevState,
      is_tiebreak: e.target.checked,
    }));
  };
  const handleSaveQuestion = () => {
    setLoading(true);
    question.bonus_options = question.bonus_options.filter(
      (item) => item.label !== ""
    );
    if (questionId === null) {
      axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-questions/${pickemId}`,
          question
        )
        .then(function (response) {
          navigate(`/dashboard/pickem/edit?pickem_id=${pickemId}`);
        });
    }

    if (questionId !== null) {
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-questions/${pickemId}?question_id=${questionId}`,
          question
        )
        .then(function (response) {
          window.location.reload(false);
        });
    }
  };
  const [value, setValue] = useState(0);

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  // OPTIONS handlers
  const successOptionHandler = (option) => {
    if (!question?.options) {
      question.options = [];
    }

    if (editOption === null) {
      question.options.push(option);
    }

    if (editOption !== null) {
      question.options[editOptionIndex] = option;
    }
    setQuestion({ ...question });
    setEditOption(null);
    setOpenOptionDialog(false);
  };
  const deleteOptionHandler = (optionIndex) => {
    let option = question.options[optionIndex];
    if (option?.option_id) {
      axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-options/${pickemId}?option_id=${option.option_id}`
        )
        .then(function (response) {
          question.options.splice(optionIndex, 1);
          setQuestion({ ...question });
        });
    } else {
      question.options.splice(optionIndex, 1);
      setQuestion({ ...question });
    }
  };
  const editOptionHandler = (optionIndex) => {
    setEditOption({ ...question.options[optionIndex] });
    setEditOptionIndex(optionIndex);
    setOpenOptionDialog(true);
  };
  const closeOptionDialog = () => {
    setEditOption(null);
    setOpenOptionDialog(false);
  };
  const openAddOptionDialog = () => {
    setEditOption(null);
    setOpenOptionDialog(true);
  };
  const onChoseAsset = (assetUrl) => {
    setQuestion((prevState) => ({
      ...prevState,
      [assetsTarget]: assetUrl,
    }));
    setAssetsTarget(null);
  };
  const onCloseAssetsDialog = (assetUrl) => {
    setAssetsTarget(null);
  };
  const updateOptions = () => {
    setLoading(true);
    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-questions/${pickemId}?question_id=${question.question_id}`,
        question
      )
      .then((response) => {
        window.location.reload(false);
      })
      .catch((error) => console.log("Update questions ERROR", error));
  };
  const questionMenuItems = () => {
    let menuItems = [];
    for (const groupTitle of Object.keys(groupedQuestionsList)) {
      menuItems.push(<ListSubheader>{groupTitle}</ListSubheader>);
      for (const question of groupedQuestionsList[groupTitle]) {
        menuItems.push(
          <MenuItem key={question.index} value={question.index}>
            {question.titleEn}
          </MenuItem>
        );
      }
    }
    return menuItems;
  };

  const OptionsButtons = () => (
    <Box>
      {!isOrderingMode ? (
        <>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="eva:toggle-left-outline" />}
            onClick={() => setIsOrderingMode(true)}
            sx={{ mr: 2 }}
          >
            Re-Ordering Mode
          </Button>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() => openAddOptionDialog()}
          >
            Add Option
          </Button>
        </>
      ) : (
        <>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="eva:close-outline" />}
            onClick={() => setIsOrderingMode(false)}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="eva:save-outline" />}
            onClick={() => updateOptions()}
            sx={{ mr: 2 }}
          >
            Save Order
          </Button>
        </>
      )}
    </Box>
  );

  console.log(question);
  return (
    <>
      <Helmet>
        <title> New Question </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            {questionId === null ? "New" : "Edit"} Question
          </Typography>
          <Box>
            <Button
              variant="outlined"
              startIcon={<Iconify icon="eva:close-outline" />}
              onClick={() =>
                navigate(`/dashboard/pickem/edit?pickem_id=${pickemId}`)
              }
              sx={{ mr: 2 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:save-outline" />}
              onClick={() => handleSaveQuestion()}
              disabled={
                loading || question.view_type === null || !question.title_en
              }
            >
              Save
            </Button>
          </Box>
        </Stack>

        <Card style={{ padding: 20 }}>
          <Typography variant="h5" component="div" sx={{ marginBottom: 2 }}>
            Settings
          </Typography>
          {loading || question === null ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id="category-select-label">Сategory</InputLabel>
                    <Select
                      labelId="category-label"
                      id="category-select"
                      value={question.category}
                      label="Category"
                      onChange={handleChangeCategory}
                    >
                      <MenuItem value="WINS">WINS</MenuItem>
                      <MenuItem value="SAVES">SAVES</MenuItem>
                      <MenuItem value="GOALS_AGAINTS">GOALS AGAINST</MenuItem>
                      <MenuItem value="CLEAN_SHEAT">SHOUTOUT</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      View Type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={question.view_type}
                      label="Age"
                      onChange={handleChangeViewType}
                    >
                      <MenuItem value="PLAYER_LIST">PLAYER_LIST</MenuItem>
                      <MenuItem value="TEAM_LIST">TEAM_LIST</MenuItem>
                      <MenuItem value="MULTIPLE_OPTIONS">
                        MULTIPLE_OPTIONS
                      </MenuItem>
                      <MenuItem value="OVER_UNDER">OVER_UNDER</MenuItem>
                      <MenuItem value="SIX_OPTIONS">SIX_OPTIONS</MenuItem>
                      <MenuItem value="PCT_OPTIONS">PCT_OPTIONS</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="Start UTC"
                      value={moment(question.start_utc, dateFormat)}
                      onChange={handleQuestionStartChange}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                {process.env.REACT_APP_NAME !== "pepsi" ? (
                  <>
                    <Grid item xs={1}>
                      <TextField
                        id="points"
                        label="Points"
                        fullWidth
                        value={question.points}
                        variant="standard"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <TextField
                        id="bonus_points"
                        label="Bonus Points"
                        fullWidth
                        value={question.bonus_points}
                        variant="standard"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <TextField
                        id="tiebreak_score"
                        label="TieBreak Score"
                        fullWidth
                        value={question.tiebreak_score}
                        variant="standard"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={question.is_tiebreak ?? false}
                            onChange={handleChangeIsTieBreak}
                            id="is_tiebreak"
                          />
                        }
                        label="Is TieBreak"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={question.is_bonus ?? false}
                            onChange={handleChangeIsBonus}
                            id="is_bonus"
                          />
                        }
                        label="Is Bonus"
                      />
                    </Grid>
                  </>
                ) : null}

                {question.is_bonus ? (
                  <>
                    <Grid item xs={6} style={{ textAlign: "center" }}>
                      {question.bonus_image ? (
                        <>
                          <img
                            style={{
                              margin: "0 auto",
                              width: 100,
                              background: "grey",
                            }}
                            alt="Remy Sharp"
                            src={question.bonus_image}
                          />
                          <Iconify
                            icon="eva:edit-outline"
                            sx={{ width: 20, height: 20, cursor: "pointer" }}
                            onClick={() => setAssetsTarget("bonus_image")}
                          />
                          <Iconify
                            icon="eva:close-outline"
                            sx={{ width: 20, height: 20, cursor: "pointer" }}
                            onClick={() => deleteImage("bonus_image")}
                          />
                        </>
                      ) : (
                        <Iconify
                          icon="eva:plus-circle-outline"
                          sx={{
                            width: 20,
                            height: 20,
                            cursor: "pointer",
                            marginTop: 2,
                            marginBottom: 2,
                          }}
                          onClick={() => setAssetsTarget("bonus_image")}
                        />
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <InputLabel id="bonus-type-select-label">
                          Bonus Type
                        </InputLabel>
                        <Select
                          labelId="bonus-type-select-label"
                          id="bonus_type"
                          value={question.bonus_type}
                          label="Bonus Type"
                          onChange={handleChangeBonusType}
                        >
                          <MenuItem value="2X">2X</MenuItem>
                          <MenuItem value="3X">3X</MenuItem>
                          <MenuItem value="4X">4X</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </>
          )}
          <Grid container xs={12} style={{ marginTop: 30 }}>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <Box>Main Image</Box>
              {question?.main_image ? (
                <>
                  <img
                    style={{
                      margin: "0 auto",
                      width: 100,
                      background: "white",
                    }}
                    alt="Remy Sharp"
                    src={question.main_image}
                  />
                  <Iconify
                    icon="eva:edit-outline"
                    sx={{ width: 20, height: 20, cursor: "pointer" }}
                    onClick={() => setAssetsTarget("main_image")}
                  />
                  <Iconify
                    icon="eva:close-outline"
                    sx={{ width: 20, height: 20, cursor: "pointer" }}
                    onClick={() => deleteImage("main_image")}
                  />
                </>
              ) : (
                <Iconify
                  icon="eva:plus-circle-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                    marginTop: 2,
                    marginBottom: 2,
                  }}
                  onClick={() => setAssetsTarget("main_image")}
                />
              )}
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <Box>Secondary Image</Box>
              {question?.secondary_image ? (
                <>
                  <img
                    style={{
                      margin: "0 auto",
                      width: 100,
                      background: "white",
                    }}
                    alt="Remy Sharp"
                    src={question.secondary_image}
                  />
                  <Iconify
                    icon="eva:edit-outline"
                    sx={{ width: 20, height: 20, cursor: "pointer" }}
                    onClick={() => setAssetsTarget("secondary_image")}
                  />
                  <Iconify
                    icon="eva:close-outline"
                    sx={{ width: 20, height: 20, cursor: "pointer" }}
                    onClick={() => deleteImage("secondary_image")}
                  />
                </>
              ) : (
                <Iconify
                  icon="eva:plus-circle-outline"
                  sx={{
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                    marginTop: 2,
                    marginBottom: 2,
                  }}
                  onClick={() => setAssetsTarget("secondary_image")}
                />
              )}
            </Grid>
          </Grid>
        </Card>
        {process.env.REACT_APP_NAME === "olybet" ? null : (
          <Card style={{ padding: 20 }} sx={{ mt: 2 }}>
            <Typography variant="h5" component="div" sx={{ marginBottom: 2 }}>
              Bonus Options
            </Typography>
            <Grid container spacing={2}>
              {question !== null &&
                question?.bonus_options?.map((option, index) => (
                  <Grid item xs={1}>
                    <TextField
                      id="title_en"
                      label={`Option ${index}`}
                      fullWidth
                      value={question.bonus_options[index].label ?? ""}
                      variant="standard"
                      onChange={(e) => handleChangeBonusOptionLabel(e, index)}
                    />
                  </Grid>
                ))}
            </Grid>
          </Card>
        )}

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={0}
          mt={2}
        >
          <Typography variant="h4" gutterBottom></Typography>
          <OptionsButtons />
        </Stack>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
            >
              <Tab label="English" {...a11yProps(0)} />
              <Tab label="French" {...a11yProps(1)} />
              <Tab label="Slovak" {...a11yProps(2)} />
              <Tab label="Estonian" {...a11yProps(3)} />
              <Tab label="Latvian" {...a11yProps(4)} />
              <Tab label="Russian" {...a11yProps(5)} />
              {!isOlybet && <Tab label="Spanish" {...a11yProps(6)} />}
              {!isOlybet && <Tab label="German" {...a11yProps(7)} />}
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Card sx={{ padding: 4 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="question-titile-select-label">
                        Question Title
                      </InputLabel>
                      <Select
                        labelId="question-titile-label"
                        id="question-titile-select"
                        value={questionTitleIndex}
                        label="Question Title"
                        onChange={handleChangeQuestionTitle}
                      >
                        {questionMenuItems().map((item) => item)}
                      </Select>
                    </FormControl>
                  </Grid>
                  {questionTitleIndex === 0 ||
                  process.env.REACT_APP_NAME === "pepsi" ? (
                    <TextField
                      id="title_en"
                      label="Custom Title"
                      fullWidth
                      value={question.title_en}
                      variant="standard"
                      onChange={handleChange}
                    />
                  ) : null}

                  <TextField
                    id="description_en"
                    label="Description"
                    fullWidth
                    value={question.description_en}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="question_type"
                    label="Question Type"
                    fullWidth
                    value={question.question_type}
                    variant="standard"
                    onChange={handleChange}
                    disabled={true}
                  />
                </>
              )}
            </Card>
            <Card sx={{ padding: 4, marginTop: 1 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {question?.options ? (
                    isOrderingMode ? (
                      <OptionsOrderingTable
                        options={question.options}
                        reorderHandler={reorderOptionsHandler}
                      />
                    ) : (
                      <OptionsTable
                        lang={"en"}
                        options={question.options}
                        deleteOptionHandler={deleteOptionHandler}
                        editOptionHandler={editOptionHandler}
                      />
                    )
                  ) : null}
                </>
              )}
            </Card>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Card sx={{ padding: 4 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <TextField
                    id="title_fr"
                    label="Custom Title"
                    fullWidth
                    value={question.title_fr}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="description_fr"
                    label="Description"
                    fullWidth
                    value={question.description_fr}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="question_type"
                    label="Question Type"
                    fullWidth
                    value={question.question_type}
                    variant="standard"
                    onChange={handleChange}
                    disabled={true}
                  />
                </>
              )}
            </Card>
            <Card sx={{ padding: 4, marginTop: 1 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {question?.options ? (
                    isOrderingMode ? (
                      <OptionsOrderingTable
                        options={question.options}
                        reorderHandler={reorderOptionsHandler}
                      />
                    ) : (
                      <OptionsTable
                        lang={"fr"}
                        options={question.options}
                        deleteOptionHandler={deleteOptionHandler}
                        editOptionHandler={editOptionHandler}
                      />
                    )
                  ) : null}
                </>
              )}
            </Card>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Card sx={{ padding: 4 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <TextField
                    id="title_sl"
                    label="Custom Title"
                    fullWidth
                    value={question.title_sl}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="description_sl"
                    label="Description"
                    fullWidth
                    value={question.description_sl}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="question_type"
                    label="Question Type"
                    fullWidth
                    value={question.question_type}
                    variant="standard"
                    onChange={handleChange}
                    disabled={true}
                  />
                </>
              )}
            </Card>
            <Card sx={{ padding: 4, marginTop: 1 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {question?.options ? (
                    isOrderingMode ? (
                      <OptionsOrderingTable
                        options={question.options}
                        reorderHandler={reorderOptionsHandler}
                      />
                    ) : (
                      <OptionsTable
                        lang={"sl"}
                        options={question.options}
                        deleteOptionHandler={deleteOptionHandler}
                        editOptionHandler={editOptionHandler}
                      />
                    )
                  ) : null}
                </>
              )}
            </Card>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Card sx={{ padding: 4 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <TextField
                    id="title_es"
                    label="Custom Title"
                    fullWidth
                    value={question.title_es}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="description_es"
                    label="Description"
                    fullWidth
                    value={question.description_es}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="question_type"
                    label="Question Type"
                    fullWidth
                    value={question.question_type}
                    variant="standard"
                    onChange={handleChange}
                    disabled={true}
                  />
                </>
              )}
            </Card>
            <Card sx={{ padding: 4, marginTop: 1 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {question?.options ? (
                    isOrderingMode ? (
                      <OptionsOrderingTable
                        options={question.options}
                        reorderHandler={reorderOptionsHandler}
                      />
                    ) : (
                      <OptionsTable
                        lang={"es"}
                        options={question.options}
                        deleteOptionHandler={deleteOptionHandler}
                        editOptionHandler={editOptionHandler}
                      />
                    )
                  ) : null}
                </>
              )}
            </Card>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <Card sx={{ padding: 4 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <TextField
                    id="title_lt"
                    label="Custom Title"
                    fullWidth
                    value={question.title_lt}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="description_lt"
                    label="Description"
                    fullWidth
                    value={question.description_lt}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="question_type"
                    label="Question Type"
                    fullWidth
                    value={question.question_type}
                    variant="standard"
                    onChange={handleChange}
                    disabled={true}
                  />
                </>
              )}
            </Card>
            <Card sx={{ padding: 4, marginTop: 1 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {question?.options ? (
                    isOrderingMode ? (
                      <OptionsOrderingTable
                        options={question.options}
                        reorderHandler={reorderOptionsHandler}
                      />
                    ) : (
                      <OptionsTable
                        lang={"lt"}
                        options={question.options}
                        deleteOptionHandler={deleteOptionHandler}
                        editOptionHandler={editOptionHandler}
                      />
                    )
                  ) : null}
                </>
              )}
            </Card>
          </TabPanel>
          <TabPanel value={value} index={5}>
            <Card sx={{ padding: 4 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <TextField
                    id="title_rus"
                    label="Custom Title"
                    fullWidth
                    value={question.title_rus}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="description_rus"
                    label="Description"
                    fullWidth
                    value={question.description_rus}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="question_type"
                    label="Question Type"
                    fullWidth
                    value={question.question_type}
                    variant="standard"
                    onChange={handleChange}
                    disabled={true}
                  />
                </>
              )}
            </Card>
            <Card sx={{ padding: 4, marginTop: 1 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {question?.options ? (
                    isOrderingMode ? (
                      <OptionsOrderingTable
                        options={question.options}
                        reorderHandler={reorderOptionsHandler}
                      />
                    ) : (
                      <OptionsTable
                        lang={"rus"}
                        options={question.options}
                        deleteOptionHandler={deleteOptionHandler}
                        editOptionHandler={editOptionHandler}
                      />
                    )
                  ) : null}
                </>
              )}
            </Card>
          </TabPanel>
          <TabPanel value={value} index={6}>
            <Card sx={{ padding: 4 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <TextField
                    id="title_esp"
                    label="Custom Title"
                    fullWidth
                    value={question.title_esp}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="description_esp"
                    label="Description"
                    fullWidth
                    value={question.description_esp}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="question_type"
                    label="Question Type"
                    fullWidth
                    value={question.question_type}
                    variant="standard"
                    onChange={handleChange}
                    disabled={true}
                  />
                </>
              )}
            </Card>
            <Card sx={{ padding: 4, marginTop: 1 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {question?.options ? (
                    isOrderingMode ? (
                      <OptionsOrderingTable
                        options={question.options}
                        reorderHandler={reorderOptionsHandler}
                      />
                    ) : (
                      <OptionsTable
                        lang={"esp"}
                        options={question.options}
                        deleteOptionHandler={deleteOptionHandler}
                        editOptionHandler={editOptionHandler}
                      />
                    )
                  ) : null}
                </>
              )}
            </Card>
          </TabPanel>
          <TabPanel value={value} index={7}>
            <Card sx={{ padding: 4 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <TextField
                    id="title_de"
                    label="Custom Title"
                    fullWidth
                    value={question.title_de}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="description_de"
                    label="Description"
                    fullWidth
                    value={question.description_de}
                    variant="standard"
                    onChange={handleChange}
                  />
                  <TextField
                    id="question_type"
                    label="Question Type"
                    fullWidth
                    value={question.question_type}
                    variant="standard"
                    onChange={handleChange}
                    disabled={true}
                  />
                </>
              )}
            </Card>
            <Card sx={{ padding: 4, marginTop: 1 }}>
              {loading || question === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {question?.options ? (
                    isOrderingMode ? (
                      <OptionsOrderingTable
                        options={question.options}
                        reorderHandler={reorderOptionsHandler}
                      />
                    ) : (
                      <OptionsTable
                        lang={"de"}
                        options={question.options}
                        deleteOptionHandler={deleteOptionHandler}
                        editOptionHandler={editOptionHandler}
                      />
                    )
                  ) : null}
                </>
              )}
            </Card>
          </TabPanel>
        </Box>
      </Container>
      <OptionDialog
        option={editOption}
        open={openOptionDialog}
        onSuccessHandler={successOptionHandler}
        onClose={closeOptionDialog}
      />
      {assetsTarget !== null ? (
        <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
      ) : null}
    </>
  );
}
